var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNameShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 414,
    viewBox: "0 0 414 414",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M493.809 280.502C459.92 324.533 383.751 407.345 350.185 386.348C308.228 360.102 416.279 232.003 350.607 190.922C284.935 149.84 180.773 267.664 136.991 240.276C93.2099 212.889 336.966 141.726 237.545 79.5328C138.125 17.3399 109.247 262.313 24.4203 209.249C-60.4062 156.186 201.131 -14.4062 -3.58387 32.8919",
    stroke: "#161F21",
    strokeWidth: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameShape);
export default __webpack_public_path__ + "static/media/nameShape.9fa83d8aa57da0d42ec47bf7733b6d04.svg";
export { ForwardRef as ReactComponent };